<!--护士-->
<template>
	<div class="item" :class="{ 'item-alarm': roomData.hasAlarm }">
		<div v-if="showAlarmActions" class="alarm-actions">
			<button class="alarm-action alarm-action-cancel" type="button" @click.stop="$emit('cancel-alarm')">
				<img src="./../../../assets/img/icon_home_cancel_alarm_icon.png" alt="" />
				<span>取消报警</span>
			</button>
			<button class="alarm-action alarm-action-detail" type="button" @click.stop="$emit('view-detail')">
				查看房间详情
			</button>
		</div>
    <div class="title">{{ roomData.buAndFlName }}</div>
    <div class="title-room">{{ roomData.roomName }}</div>
    <div class="equipment-con">
      <div
        v-for="(item, index) in roomData.bedList"
        :key="index"
        class="equipment"
      >
        <div class="warning-circle-fill">
          <img
            v-show="
              item.statusName == '离床过久' ||
			  (item.statusName == '疑似生命体征微弱' && item.status != 1) ||
				item.statusName == '呼吸暂停' ||
				item.statusName == '心跳过速' ||
				item.statusName == '呼吸过速' ||
				item.statusName == '心跳过缓' ||
				item.sosStatusName == '需要帮助'
            "
            src="./../../../assets/img/warning-circle-fill@2x.png"
            alt=""
            srcset=""
          />
        </div>
        <div
          class="equipment-left"
          :class="{
            'alarm-status':
              item.statusName == '离床过久' ||
			  (item.statusName == '疑似生命体征微弱' && item.status != 1) ||
              item.statusName == '呼吸暂停' ||
              item.statusName == '心跳过速' ||
              item.statusName == '呼吸过速' ||
              item.statusName == '心跳过缓' || 
			  item.sosStatusName == '需要帮助'
          }"
        >
          {{ item.bedName }}
        </div>
		
		<div>
			<div style="display: flex;">
				<div class="equipment-icon">
		          <div v-if="item.radarType == 1" class="sleep">
		            <img
		              v-if="item.statusName === '睡觉'"
		              src="./../../../assets/img/iconSleep_blue@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '清醒'"
		              src="./../../../assets/img/iconSleep_blue@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '离床'"
		              src="./../../../assets/img/iconSleep@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '离线'"
		              src="./../../../assets/img/iconSleep_grey@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '关闭'"
		              src="./../../../assets/img/iconSleep_grey@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '离床过久'"
		              src="./../../../assets/img/iconSleepAlarm_red@2x.png"
		              alt=""
		              srcset=""
		            />
					<img
		              v-if="item.statusName === '疑似生命体征微弱' && item.status != 1"
		              src="./../../../assets/img/iconSleepAlarm_red@2x.png"
		              alt=""
		              srcset=""
		            />
					<img
		              v-if="item.statusName === '疑似生命体征微弱' && item.status == 1"
		              src="./../../../assets/img/iconSleep@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '呼吸暂停'"
		              src="./../../../assets/img/iconSleep_Red@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '呼吸过速'"
		              src="./../../../assets/img/iconSleep_Red@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '心跳过速'"
		              src="./../../../assets/img/iconSleep_Red@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '心跳过缓'"
		              src="./../../../assets/img/iconSleep_Red@2x.png"
		              alt=""
		              srcset=""
		            />
		          </div>
		          <div v-if="item.radarType == 2" class="toilet">
		            <img
		              v-if="item.statusName === '有人'"
		              src="./../../../assets/img/iconToilet_blueH@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '无人'"
		              src="./../../../assets/img/iconToilet_grey@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '离线'"
		              src="./../../../assets/img/iconToilet_grey@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '关闭'"
		              src="./../../../assets/img/iconToilet_grey@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '跌倒' || item.statusName === '已跌倒'"
		              src="./../../../assets/img/iconToilet_red@2x.png"
		              alt=""
		              srcset=""
		            />
		            <img
		              v-if="item.statusName === '卫生间停留过久'"
		              src="./../../../assets/img/iconToilet_red@2x.png"
		              alt=""
		              srcset=""
		            />
		          </div>
		        </div>
		        <div
		          class="equipment-right"
		          :class="{
		          	'alarm-status':
		          		item.statusName == '离床过久' ||
						(item.statusName == '疑似生命体征微弱' && item.status != 1) ||
		          		item.statusName == '呼吸暂停' ||
		          		item.statusName == '心跳过速' ||
		          		item.statusName == '呼吸过速' ||
		          		item.statusName == '心跳过缓' ||
		          		item.statusName == '离线' ||
		          		item.statusName == '卫生间停留过久' ||
		          		item.statusName == '跌倒' ||
		          		item.statusName == '已跌倒',
		          	'close-status': item.statusName == '关闭',
		          }"
		          :style="{ color: item.statusName == '无人' ? '#8C8C8C' : '' }"
		        >
		          {{ item.statusName }}
		        </div>
			</div>

			<div v-if="item.sosStatusName" style="display: flex; margin-top: 9px;" :style="{marginTop: item.statusName ? '9px' : '0px'}">
				<div class="equipment-icon">
		          <div class="sleep">
		            <img
					  v-if="item.sosSubStatus == 102"
					  style="width: 32px; height: 24px;"
		              src="./../../../assets/icon_sos_btn_bell_2.png"
		              alt=""
		              srcset=""
		            />
					<img
					  v-if="item.sosSubStatus == 101"
					  style="width: 24px; height: 24px;"
		              src="./../../../assets/icon_sos_btn_bell_1.png"
		              alt=""
		              srcset=""
		            />
		          </div>
		        </div>
		        <div
		          class="equipment-right"
		          :class="{
		          	'alarm-status': item.sosSubStatus == 102,
		          	'close-status': item.sosSubStatus == 101,
		          }"
		        >
		          {{ item.sosStatusName || '' }}
		        </div>
				</div>
			</div>

        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    roomData: {
      type: Object,
      default: () => {},
    },
		showAlarmActions: {
			type: Boolean,
			default: false,
		},
  },
  components: {},
  data() {
    return {
      isShowRedText: false,
    };
  },
  created() {
    console.log(this.roomData);
  },
  mounted() {},
  methods: {},
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.item {
	position: relative;
  width: 205px;
  background: #fff;
  text-align: center;
  margin: 5px;
  box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  padding: 15px 0;
	overflow: hidden;
	.alarm-actions {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 2;
		display: none;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 15px;
		border-radius: 8px;
		background: rgba(255, 77, 79, 0.16);
		backdrop-filter: blur(2px);
		-webkit-backdrop-filter: blur(2px);
	}
	.alarm-action {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 101px;
		height: 30px;
		padding: 0;
		border-radius: 16px;
		background: #fff;
		font-family: PingFangSC, 'PingFang SC';
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		cursor: pointer;
		box-sizing: border-box;

		img {
			width: 16px;
			height: 16px;
			margin-right: 5px;
		}
	}
	.alarm-action-cancel {
		border: 1px solid rgba(255, 77, 79, 0.5);
		color: rgba(255, 77, 79, 1);
	}
	.alarm-action-detail {
		border: 1px solid #fff;
		color: rgba(38, 38, 38, 1);
	}
  .title {
    color: #262626;
    font-size: 14px;
  }
  .title-room {
    color: #262626;
    font-size: 24px;
  }
  .warning-circle-fill {
    width: 12px;
    height: 12px;
    line-height: 12px;
    img {
      width: 12px;
      height: 12px;
      margin-right: 5px;
    }
  }
  .equipment-con {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .equipment {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px 0;
    .equipment-icon {
      margin: 0 10px;
      width: 25px;
      .sleep {
        img {
          width: 26px;
          height: 20px;
        }
      }
      .toilet {
        img {
          width: 21px;
          height: 25px;
        }
      }
    }
    .equipment-left {
      width: 56px;
      margin-left: 3px;
      word-wrap: break-word;
      text-align: right;
      color: #8c8c8c;
      font-size: 14px;
    }

    .equipment-right {
      width: 65px;
      text-align: left;
      color: #262626;
      font-size: 14px;
    }
    .alarm-status {
      color: #ff4d4f;
    }
    .close-status {
      color: #8c8c8c;
    }
  }
  .equipment:hover {
    cursor: pointer;
  }
}
.item:hover {
  background: #e6f7ff;

	.alarm-actions {
		display: flex;
	}
}
.item-alarm {
  box-shadow: 0px 0px 16px 0px #ff4d4f, 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
  border-radius: 8px;

  animation: alarm 1s infinite;
}
@keyframes alarm {
  from {
    box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
    border: 1px solid #fff;
  }
  to {
    border: 1px solid #ff4d4f;
    box-shadow: 0px 0px 16px 0px #ff4d4f, 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
  }
}
</style>
